import { defineDirective, IOmniaSession, IUibModalScope } from "../omnia"
import { RowViewModel } from "../table/rowViewModel"
import { ISoilService } from "../types"

export interface IFieldSelectionViewModel {

    fieldId: number;
    description: string;
    datalayerId: number;
    selected: boolean;
    disabled: boolean;

}

export class GeneratePopupCtrl {

    static create(): ng.IDirective {

        return defineDirective(GeneratePopupCtrl, "app/soil/generate/generatePopup.html", {});

    }

    static $inject = ["$scope", "OmniaSession", "OmniaSoilService"];

    private $scope: IUibModalScope;

    public fieldSelection: IFieldSelectionViewModel[];

    constructor($scope: ng.IScope, private session: IOmniaSession, private svc: ISoilService) {
        this.$scope = <IUibModalScope>$scope.$parent;

        var optionsScope = this.$scope.$parent;

        if (optionsScope && optionsScope["fields"]) {
            var fields = <RowViewModel[]>optionsScope["fields"];
            this.fieldSelection = fields.map(r => {
                return {
                    fieldId: r.fieldId,
                    description: r.fieldDescription,
                    datalayerId: r.soilAnalysisLayerId,
                    selected: !r.SoilAnalysisId,
                    disabled: r.soilAnalysis && r.soilAnalysis.CalculatedAverage
                };
            }).sort((a, b) => a.description > b.description ? 1 : a.description < b.description ? -1 : 0);
        }
    }

    unselectAll() {
        this.fieldSelection.forEach(f => f.selected = false);
    }

    selectAll() {
        this.fieldSelection.forEach(f => f.selected = true);
    }

    canCommit(): boolean {
        return this.fieldSelection.filter(s => s.selected).length > 0;
    }

    commit() {
        this.svc.generateSoilAnalysis(this.fieldSelection.filter(s => s.selected).map(f => {
            return {
                fieldId: f.fieldId,
                datalayerId: f.datalayerId
            };
        })).then(r => this.$scope.$close());
    }

    close() {
        this.$scope.$close();
    }
}
